module.exports = __webpack_public_path__ + "static/img/12.2a3ffd3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/zh/12.png
// module id = tuFm
// module chunks = 0